import { Injectable } from '@angular/core';
import Endpoints from '../endpoints';
import { HttpClient } from '@angular/common/http';
import {
  OrganisationHourlyAvgInsidersForMonthDTO, OrganisationHourlyAvgVisitorsForMonthDTO,
  OrganisationVisitorsPerDayDTO, OrganisationVisitorsPerMonthDTO, OrganisationVisitorsPerWeekDTO
} from '../types/dashboard';
import { Observable } from 'rxjs';

@Injectable()
export class DashboardService {
  constructor(private http: HttpClient) {}

  public getVisitorAnalytics(date: string, organisation: string, site: string): Observable<any[]> {
    return this.http.get<any[]>(Endpoints.GET_VISITOR_ANALYTICS(date, organisation, site));
  }

  public getSiteHourlyAvgInsidersForMonth(date: string, organisation: string, site: string): Observable<OrganisationHourlyAvgInsidersForMonthDTO[]> {
    return this.http.get<OrganisationHourlyAvgInsidersForMonthDTO[]>(Endpoints.GET_SITE_HOURLY_AVG_INSIDERS_FOR_MONTH(date, organisation, site));
  }

  public getSiteHourlyAvgVisitorsForMonth(date: string, organisation: string, site: string): Observable<OrganisationHourlyAvgVisitorsForMonthDTO[]> {
    return this.http.get<OrganisationHourlyAvgVisitorsForMonthDTO[]>(Endpoints.GET_SITE_HOURLY_AVG_VISITORS_FOR_MONTH(date, organisation, site));
  }

  public getSiteVisitorsPerMonth(date: string, organisation: string, site: string): Observable<OrganisationVisitorsPerMonthDTO[]> {
    return this.http.get<OrganisationVisitorsPerMonthDTO[]>(Endpoints.GET_SITE_VISITORS_PER_MONTH(date, organisation, site));
  }

  public getSiteVisitorsPerWeek(date: string, organisation: string, site: string): Observable<OrganisationVisitorsPerWeekDTO[]> {
    return this.http.get<OrganisationVisitorsPerWeekDTO[]>(Endpoints.GET_SITE_VISITORS_PER_WEEK(date, organisation, site));
  }

  public getSiteVisitorsPerDay(date: string, organisation: string, site: string): Observable<OrganisationVisitorsPerDayDTO[]> {
    return this.http.get<OrganisationVisitorsPerDayDTO[]>(Endpoints.GET_SITE_VISITORS_PER_DAY(date, organisation, site));
  }
}
